<div fxFlex fxLayoutAlign="center center" fxLayout="column" class="full-height">
  <mat-spinner></mat-spinner>
  <br />
  <h1>Loading...</h1>
</div>
